import { gql, TypedDocumentNode } from "@apollo/client";

import {
  MutationStackScheduledDeleteCreateArgs,
  ScheduledDelete,
  ScheduledDeleteInput,
} from "types/generated";

type CreateStackSchedulingScheduledDeleteData = {
  stackScheduledDeleteCreate: Pick<ScheduledDelete, "id">;
};

export const CREATE_STACK_SCHEDULING_SCHEDULED_DELETE: TypedDocumentNode<
  CreateStackSchedulingScheduledDeleteData,
  MutationStackScheduledDeleteCreateArgs
> = gql`
  mutation CreateStackSchedulingScheduledDelete($stack: ID!, $input: ScheduledDeleteInput!) {
    stackScheduledDeleteCreate(stack: $stack, input: $input) {
      id
    }
  }
`;

type UpdateStackSchedulingScheduledDeleteData = {
  stackScheduledDeleteUpdate: Pick<ScheduledDelete, "id">;
};

type UpdateStackSchedulingScheduledDeleteVariables = {
  scheduleId: string;
  stack: string;
  input: ScheduledDeleteInput;
};

export const UPDATE_STACK_SCHEDULING_SCHEDULED_DELETE: TypedDocumentNode<
  UpdateStackSchedulingScheduledDeleteData,
  UpdateStackSchedulingScheduledDeleteVariables
> = gql`
  mutation UpdateStackSchedulingScheduledDelete(
    $scheduleId: ID!
    $stack: ID!
    $input: ScheduledDeleteInput!
  ) {
    stackScheduledDeleteUpdate(scheduledDelete: $scheduleId, stack: $stack, input: $input) {
      id
    }
  }
`;

type RemoveStackSchedulingScheduledDeleteData = {
  stackScheduledDeleteDelete: Pick<ScheduledDelete, "id"> | null;
};

type RemoveStackSchedulingScheduledDeleteVariables = {
  scheduleId: string;
  stack: string;
};

export const REMOVE_STACK_SCHEDULING_SCHEDULED_DELETE: TypedDocumentNode<
  RemoveStackSchedulingScheduledDeleteData,
  RemoveStackSchedulingScheduledDeleteVariables
> = gql`
  mutation RemoveStackSchedulingScheduledDelete($scheduleId: ID!, $stack: ID!) {
    stackScheduledDeleteDelete(scheduledDelete: $scheduleId, stack: $stack) {
      id
    }
  }
`;
